export default {
  ICICI: `icici`,
  IBL: 'ibl',
  RBL: `rbl`,
  YES_BANK: 'yes_bank',
  IDFC: 'idfc',
  HDFC: 'hdfc',
  DBS: 'dbs',
  AXIS: 'axis'
};
